import { PERMISSIONS, type Role } from '@agentwiki/shared'

/** Mirrors API wildcard permission matching for authenticated Web capability gates. */
export function roleHasPermission(role: Role | null, permission: string): boolean {
  if (!role) return false
  const [resource, action] = permission.split(':')
  return PERMISSIONS[role].some((candidate) => {
    const [candidateResource, candidateAction] = candidate.split(':')
    return (
      (candidateResource === resource || candidateResource === '*') &&
      (candidateAction === action || candidateAction === '*')
    )
  })
}
